import currency from "barcelo-shared/currency";

const sharedModulesByName = {
  currency,
};

const ensureSharedRegistry = function () {
  if (!window.bcl) window.bcl = {};
  if (!window.bcl.s) window.bcl.s = {};
  return window.bcl.s;
};

const isModuleRegistered = function (moduleName) {
  const sharedRegistry = window.bcl && window.bcl.s;
  return !!(sharedRegistry && Object.prototype.hasOwnProperty.call(sharedRegistry, moduleName));
};

const shouldInitSharedModule = function (module) {
  try {
    if (!module) return false;
    if (typeof module.isPresent === "function") return !!module.isPresent({ root: document });
    if (typeof module.selector === "string" && module.selector) return !!document.querySelector(module.selector);
    return true;
  } catch {
    return true;
  }
};

const BarceloShared = {
  init: function () {
    const sharedRegistry = ensureSharedRegistry();

    for (const moduleName in sharedModulesByName) {
      if (!Object.prototype.hasOwnProperty.call(sharedModulesByName, moduleName)) continue;
      if (isModuleRegistered(moduleName)) continue;

      const module = sharedModulesByName[moduleName];
      if (!module || typeof module.init !== "function") continue;
      if (!shouldInitSharedModule(module)) continue;

      module.init();
      sharedRegistry[moduleName] = module;
    }

    if (!isModuleRegistered("swiperMobile") && document.querySelector("[data-swiper]")) {
      import("barcelo-shared/swiperMobile").then((mod) => {
        const module = mod.default;
        if (shouldInitSharedModule(module)) {
          module.init();
          sharedRegistry["swiperMobile"] = module;
        }
      });
    }
  },
};

export { BarceloShared };
